import { TASKS_POPUP_PERIOD_EVENTS } from '.';

export const taskPopupPeriodCalendarEventMap = {
  'date-selected': TASKS_POPUP_PERIOD_EVENTS.TASK_FINISH_DATE,
};

export const taskPopupModes = {
  create: {
    title: 'Додати завдання',
    name: {
      subtitle: 'Назва',
      placeholder: 'Назва завдання',
    },
    description: {
      subtitle: 'Опис задачі',
      placeholder: 'Опис завдання',
    },
    date: {
      subtitle: 'Дата виконання',
    },
    file: {
      subtitle: 'Файл завдання',
    },
    submit: 'Створити задачу',
  },
  edit: {
    title: 'Редагувати завдання',
    name: {
      subtitle: 'Назва',
      placeholder: 'Назва завдання',
    },
    description: {
      subtitle: 'Опис задачі',
      placeholder: 'Опис завдання',
    },
    date: {
      subtitle: 'Дата завдання',
    },
    file: {
      subtitle: 'Файл завдання',
    },
    submit: 'Редагувати задачу',
  },
};
